import { type PropType } from "vue";

export type TimeUnit = "hours" | "minutes" | "seconds";
export type TimeFormat = "HH:mm:ss" | "HH:mm" | "HH" | "mm" | "ss";
export type TimeObject = { hours?: string; minutes?: string; seconds?: string };
export type TimeValue = string | Date | TimeObject | undefined;

export interface TimepickerProps {
    modelValue?: TimeValue;
    format?: TimeFormat;
    only?: TimeUnit;
    returnObject?: boolean;
}

export const timepickerProps = {
    modelValue: {
        type: [String, Object, Date] as PropType<TimeValue>,
        default: undefined,
        required: false,
    },
    format: {
        type: String as PropType<TimeFormat>,
        default: "HH:mm:ss",
        required: false,
    },
    only: {
        type: String as PropType<TimeUnit>,
        default: undefined,
        required: false,
    },
    returnObject: {
        type: Boolean as PropType<boolean>,
        default: false,
        required: false,
    },
};

export const timepickerEmits = {
    "update:modelValue": (_value: string | TimeObject) => true,
};
